import { JsFormResponseHandlerObject } from "../general/modules/jsFormTypes";
import { LoginFormContent } from "../view/login-form-content";
import { PopupManager } from "../popups/popupManager";
import { PopupIds } from "../constants/PopupIds";
// @ts-ignore
import * as errorToolTip from '../general/errorToolTip';
import { HubJsonRpcRequest } from "../api/HubJsonRpcRequest";
import { HubApiMethods } from "../constants/HubApiMethods";
import { getUrlToLoginViaToken } from "./getUrlToLoginViaToken";
import { addLoginQueryParams } from "../utils/url";
import { GetUserTokenType, HubApiError } from "../domains/valueObject/SwitchUserProgressResponses";
import axios from "axios";
import { Localization } from "../localization/localization";

enum LoginErrorCode {
    COMMON_ERROR = 0,
    NOT_REGISTERED = 1,
    WRONG_PASSWORD = 2,
    REQUIRED_2FA = 3,
    INVALID_2FA = 4,
    FORCE_PASS_CHANGE = 5,
    USER_MUST_CHANGE_PASSWORD = 11,
    EMAIL_EMPTY = 6,
    PASS_EMPTY = 7,
    TO_BE_DELETED = 5006,
    ACCOUNT_IS_TRANSFERRED = 410
}

type LoginError = {
    error?: {
        code: number,
        message: string
        data?: {
            id: number,
            token: string,
            deleteAt: string
        }
    }
}

function emailLoginFormHandler(data: JsFormResponseHandlerObject<LoginError>): void {
    const response = data.response;
    const loginForm = LoginFormContent.fromForm(data.form, data.caller.data('tooltipdirection'));

    loginForm.hideErrors();

    if (response.error) {
        if ([LoginErrorCode.EMAIL_EMPTY].includes(response.error.code)) {
            loginForm.showEmailError(response.error.message);
            return;
        }

        if ([
            LoginErrorCode.PASS_EMPTY,
            LoginErrorCode.WRONG_PASSWORD
        ].includes(response.error.code)) {
            loginForm.showPasswordError(response.error.message);
            return;
        }

        if ([
            LoginErrorCode.FORCE_PASS_CHANGE,
            LoginErrorCode.USER_MUST_CHANGE_PASSWORD
        ].includes(response.error.code)) {
            PopupManager.openSingle(PopupIds.RESTORE_PASS);

            setTimeout(() => {
                const restoreButton = $('.restore-form__restore-button:visible');
                errorToolTip(restoreButton, this.showTooltipOnLeft, response.error.message);
                const email = $('input[name=email]', data.form).val() as string;
                fillRestorePassEmail(email);
            }, 100);
            // window.app.popup(PopupOpenConfigStorage.getPopupOpenConfig(PopupIds.RESTORE_PASS));
            return;
        }

        if ([
            LoginErrorCode.REQUIRED_2FA,
            LoginErrorCode.INVALID_2FA
        ].includes(response.error.code)) {
            loginForm.show2FaForm();
            loginForm.show2FaError(response.error.message);
            return;
        }

        if ([LoginErrorCode.TO_BE_DELETED].includes(response.error.code)) {
            window.app.handleAccountToBeDeleted(
                response.error.data.id,
                response.error.data.token,
                response.error.data.deleteAt
            );
            return;
        }

        loginForm.showSubmitButtonError(response.error.message);
    } else {
        location.reload();
    }
}

function fillRestorePassEmail(email: string) {
    $('#restore_pass input[type="email"]').val(email);
}

async function loginThroughHub(form: JQuery): Promise<LoginError> {
    const emailField = form.find('input[type=email]');
    const email: string = (emailField.val() as string).trim();
    const passwordField = form.find('input[type=password]');
    const password: string = (passwordField.val() as string).trim();

    try {
        const hubResponse: GetUserTokenType | HubApiError = await HubJsonRpcRequest.makeRequest(
            HubApiMethods.GET_TOKEN_EMAIL,
            {
                email,
                password,
                current_entry_point: window.app.config.current_entry_point,
                locale: window.app.config.locale
            },
            window.app.deviceIdentifier
        );

        if ('error' in hubResponse) {
            if (hubResponse.error.code === LoginErrorCode.ACCOUNT_IS_TRANSFERRED) {
                window.app.handleAccountTransferredWindow();
            }
            return {
                error: {
                    code: hubResponse.error.code,
                    message: getErrorMessage(hubResponse.error.code),
                    // @ts-ignore
                    data: hubResponse.error.data
                }
            };
        }

        let url = getUrlToLoginViaToken(hubResponse.tether.token, hubResponse.tether.suid);
        url = addLoginQueryParams(url);
        await axios.get(url);

        return {};
    } catch (error) {
        window.Sentry.captureException(error);
        return {
            error: {
                code: LoginErrorCode.COMMON_ERROR,
                message: Localization._n('errors.common_error')
            }
        };
    }
}

function getErrorMessage(errorCode: number): string {
    let msg: string;
    switch (errorCode) {
        case LoginErrorCode.NOT_REGISTERED:
            msg = 'login.email_not_exists';
            break;
        case LoginErrorCode.WRONG_PASSWORD:
            msg = 'errors.pass_wrong';
            break;
        case LoginErrorCode.REQUIRED_2FA:
            msg = 'login.2fa_required_sending';
            break;
        case LoginErrorCode.INVALID_2FA:
            msg = 'login.2fa_invalid_code';
            break;
        case LoginErrorCode.FORCE_PASS_CHANGE:
        case LoginErrorCode.USER_MUST_CHANGE_PASSWORD:
            msg = 'login.must_change_password';
            break;
        case LoginErrorCode.EMAIL_EMPTY:
            msg = 'errors.email_empty';
            break;
        case LoginErrorCode.PASS_EMPTY:
            msg = 'errors.pass_empty';
            break;
        case LoginErrorCode.TO_BE_DELETED:
            msg = 'errors.account_to_be_deleted';
            break;
        case LoginErrorCode.ACCOUNT_IS_TRANSFERRED:
            msg = 'errors.account_is_transferred';
            break;
        default:
            msg = 'error.operation_failed';
    }

    return Localization._n(msg);
}

export function initLoginHandlers() {
    window.app.login_form_handler = emailLoginFormHandler;
    window.app.login_send_request_handler = loginThroughHub;
}
